import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

function TestimonialCard({ review, stars, name }) {
	return (
		<div className="testimonial-card">
			<p className="mb-0">"{review}"</p>
			<div className="testimonial-card-footer">
				{Array.from({ length: stars }).map((_, index) => (
					<FontAwesomeIcon icon={faStar} key={index} />
				))}
				<h5>{name}</h5>
			</div>
		</div>
	);
}

export default TestimonialCard;
